import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';

class HowToDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
    };

    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
  }

  componentDidMount() {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }

  onDocumentLoadSuccess(data) {
    const page = data.numPages;
    this.setState({ page: page });
  }

  render() {
    const { classes, disclaimer, dlClose, openDialog } = this.props;
    return (
      <Dialog open={openDialog} onClose={dlClose} maxWidth="xl">
        <DialogContent className={classes.dlContainer}>
          <Document
            file={disclaimer}
            onLoadSuccess={this.onDocumentLoadSuccess}
            onLoadError={console.error}
          >
            {Array(this.state.page)
              .fill(0)
              .map((_, i) => (
                <Page key={i} pageNumber={i + 1} width={window.innerWidth * 0.75} />
              ))}
          </Document>
        </DialogContent>
        <DialogActions>
          <Button onClick={dlClose} className={((this.props) && this.props.color != undefined) ?  classes.dlCloseButtonZurich : (this.props.derby ? classes.dlCloseButtonDerby : classes.dlCloseButton)}>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(useStyles)(HowToDialog);
